module.exports = __webpack_public_path__ + "fonts/iconfont.e5384920.woff";